var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssuranceLine2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 397,
    height: 82,
    viewBox: "0 0 397 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M479.609 0.956207H269.849C252.295 0.956207 235.307 7.17506 221.902 18.5093L168.728 63.4674C155.323 74.8017 138.335 81.0205 120.781 81.0205H1.54425",
    stroke: "url(#paint0_linear_72_133)",
    strokeWidth: 1.16035,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_72_133",
    x1: 479.609,
    y1: 40.9884,
    x2: 1.54425,
    y2: 40.9884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssuranceLine2);
export default __webpack_public_path__ + "static/media/assurance-line-2.36797e9fddc15d817d96d3964abc2f97.svg";
export { ForwardRef as ReactComponent };